import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { NewChartModule } from '@ddt-web/highchart-manager';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ModelAllocationChartSkeletonComponent } from './model-allocation-chart-skeleton';
import { ModelAllocationChartComponent } from './model-allocation-chart.component';


@NgModule({
	declarations: [ModelAllocationChartComponent, ModelAllocationChartSkeletonComponent],
	imports: [CommonModule, CwpNgFrameworkModule, CoreModule, NewChartModule, NgxSkeletonLoaderModule, DataServiceModule],
	exports: [ModelAllocationChartComponent, ModelAllocationChartSkeletonComponent]
})
export class ModelAllocationChartModule { }
